export default "__VITE_ASSET__DtQNZCV3__"